import { message } from "antd";
import { EmailTemplateFormCard } from "./components/EmailTemplateForm";
import { useMutation } from "@tanstack/react-query";
import { EmailTemplate } from "@rumble-it/common-lib/types/models/EmailTemplate.interface";
import { createEmailTemplate } from "../../../lib/api/resources/emailTemplates";
import { useNavigate } from "react-router-dom";

export const EmailTemplateCreate = () => {
  const navigate = useNavigate();

  const createEmailTemplateMutation = useMutation({
    mutationFn: (data: EmailTemplate) => createEmailTemplate(data),
    onSuccess: () => {
      navigate("/email-templates");
      message.success("Email Template succesvol aangemaakt");
    },
  });

  return (
    <div>
      <EmailTemplateFormCard mutation={createEmailTemplateMutation} />
    </div>
  );
};
